const poll = {
  id: '59aaa23434400000',
  description: 'קולורס מונפרד אדנדום סילקוף, מרגשי ומרגשח',
  name: 'ברומץ כלרשט',
  surveySchema: {
    locale: 'he',
    title: 'ברומץ כלרשט',
    pages: [
      {
        name: 'page1',
        elements: [
          {
            type: 'text',
            name: 'q1',
            title: 'איך אתה מרגיש היום?',
            isRequired: true,
          },
          {
            type: 'rating',
            name: 'q2',
            title: 'דרג את החוויה שלך (1-5)',
            rateMin: 1,
            rateMax: 5,
          },
          {
            type: 'comment',
            name: 'q3',
            title: 'הערות נוספות?',
          },
        ],
      },
    ],
  },
};

export default poll;
